export default {
  GET_TEMPLATES_REQUEST: '@@templates/GET_TEMPLATES_REQUEST',
  GET_TEMPLATES_SUCCESS: '@@templates/GET_TEMPLATES_SUCCESS',
  GET_TEMPLATES_ERROR: '@@templates/GET_TEMPLATES_ERROR',

  GET_CLIENT_TEMPLATES_REQUEST: '@@templates/GET_CLIENT_TEMPLATES_REQUEST',
  GET_CLIENT_TEMPLATES_SUCCESS: '@@templates/GET_CLIENT_TEMPLATES_SUCCESS',
  GET_CLIENT_TEMPLATES_ERROR: '@@templates/GET_CLIENT_TEMPLATES_ERROR',

  GET_TEMPLATE_FORM_REQUEST: '@@templates/GET_TEMPLATE_FORM_REQUEST',
  GET_TEMPLATE_FORM_SUCCESS: '@@templates/GET_TEMPLATE_FORM_SUCCESS',
  GET_TEMPLATE_FORM_ERROR: '@@templates/GET_TEMPLATE_FORM_ERROR',

  CREATE_TEMPLATE_ANSWER_REQUEST: '@@templates/CREATE_TEMPLATE_ANSWER_REQUEST',
  CREATE_TEMPLATE_ANSWER_SUCCESS: '@@templates/CREATE_TEMPLATE_ANSWER_SUCCESS',
  CREATE_TEMPLATE_ANSWER_ERROR: '@@templates/CREATE_TEMPLATE_ANSWER_ERROR',

  UPDATE_FORM_ITEM_ACCESS_REQUEST: '@@templates/UPDATE_FORM_ITEM_ACCESS_REQUEST',
  UPDATE_FORM_ITEM_ACCESS_SUCCESS: '@@templates/UPDATE_FORM_ITEM_ACCESS_SUCCESS',
  UPDATE_FORM_ITEM_ACCESS_ERROR: '@@templates/UPDATE_FORM_ITEM_ACCESS_ERROR',

  UPDATE_TEMPLATE_ANSWER_REQUEST: '@@templates/UPDATE_TEMPLATE_ANSWER_REQUEST',
  UPDATE_TEMPLATE_ANSWER_SUCCESS: '@@templates/UPDATE_TEMPLATE_ANSWER_SUCCESS',
  UPDATE_TEMPLATE_ANSWER_ERROR: '@@templates/UPDATE_TEMPLATE_ANSWER_ERROR',

  SET_CURRENT_TEMPLATE_FORM_ERROR: '@@templates/SET_CURRENT_TEMPLATE_FORM_ERROR',
  SET_CURRENT_TEMPLATE_FORM_ANSWER: '@@templates/SET_CURRENT_TEMPLATE_FORM_ANSWER',

  REMOVE_CURRENT_TEMPLATE_FORM_ERROR: '@@templates/REMOVE_CURRENT_TEMPLATE_FORM_ERROR',
  CLEAR_CURRENT_TEMPLATE_FORM: '@@templates/CLEAR_CURRENT_TEMPLATE_FORM',

  CREATE_MEDIA_STORAGE_REQUEST: '@@templates/CREATE_MEDIA_STORAGE_REQUEST',
  CREATE_MEDIA_STORAGE_SUCCESS: '@@templates/CREATE_MEDIA_STORAGE_SUCCESS',
  CREATE_MEDIA_STORAGE_ERROR: '@@templates/CREATE_MEDIA_STORAGE_ERROR',

  UPDATE_MEDIA_STORAGE_REQUEST: '@@templates/UPDATE_MEDIA_STORAGE_REQUEST',
  UPDATE_MEDIA_STORAGE_SUCCESS: '@@templates/UPDATE_MEDIA_STORAGE_SUCCESS',
  UPDATE_MEDIA_STORAGE_ERROR: '@@templates/UPDATE_MEDIA_STORAGE_ERROR',

  GET_CLIENT_FONTS_REQUEST: '@@templates/GET_FONTS_REQUEST',
  GET_CLIENT_FONTS_SUCCESS: '@@templates/GET_FONTS_SUCCESS',
  GET_CLIENT_FONTS_ERROR: '@@templates/GET_FONTS_ERROR',

  UPDATE_CLIENT_TEMPLATE_REQUEST: '@@templates/UPDATE_CLIENT_TEMPLATE_REQUEST',
  UPDATE_CLIENT_TEMPLATE_SUCCESS: '@@templates/UPDATE_CLIENT_TEMPLATE_SUCCESS',
  UPDATE_CLIENT_TEMPLATE_ERROR: '@@templates/UPDATE_CLIENT_TEMPLATE_ERROR',

  DELETE_CLIENT_TEMPLATE_REQUEST: '@@templates/DELETE_CLIENT_TEMPLATE_REQUEST',
  DELETE_CLIENT_TEMPLATE_SUCCESS: '@@templates/DELETE_CLIENT_TEMPLATE_SUCCESS',
  DELETE_CLIENT_TEMPLATE_ERROR: '@@templates/DELETE_CLIENT_TEMPLATE_ERROR',

  SAVE_TEMPLATE_TO_LIBRARY_REQUEST: '@@templates/SAVE_TEMPLATE_TO_LIBRARY_REQUEST',
  SAVE_TEMPLATE_TO_LIBRARY_SUCCESS: '@@templates/SAVE_TEMPLATE_TO_LIBRARY_SUCCESS',
  SAVE_TEMPLATE_TO_LIBRARY_ERROR: '@@templates/SAVE_TEMPLATE_TO_LIBRARY_ERROR',

  GET_RESULT_BY_INTERFACE_REQUEST: '@@templates/GET_RESULT_BY_INTERFACE_REQUEST',
  GET_RESULT_BY_INTERFACE_SUCCESS: '@@templates/GET_RESULT_BY_INTERFACE_SUCCESS',
  GET_RESULT_BY_INTERFACE_ERROR: '@@templates/GET_RESULT_BY_INTERFACE_ERROR',

  GET_RESULT_BY_CLIENT_TEMPLATE_REQUEST: '@@templates/GET_RESULT_BY_CLIENT_TEMPLATE_REQUEST',
  GET_RESULT_BY_CLIENT_TEMPLATE_SUCCESS: '@@templates/GET_RESULT_BY_CLIENT_TEMPLATE_SUCCESS',
  GET_RESULT_BY_CLIENT_TEMPLATE_ERROR: '@@templates/GET_RESULT_BY_CLIENT_TEMPLATE_ERROR',

  GET_RESULT_BY_OPERATION_TEMPLATE_REQUEST: '@@templates/GET_RESULT_BY_OPERATION_TEMPLATE_REQUEST',
  GET_RESULT_BY_OPERATION_TEMPLATE_SUCCESS: '@@templates/GET_RESULT_BY_OPERATION_TEMPLATE_SUCCESS',
  GET_RESULT_BY_OPERATION_TEMPLATE_ERROR: '@@templates/GET_RESULT_BY_OPERATION_TEMPLATE_ERROR',

  GET_RESULT_BY_EDITOR_OBJECT_REQUEST: '@@templates/GET_RESULT_BY_EDITOR_OBJECT_REQUEST',
  GET_RESULT_BY_EDITOR_OBJECT_SUCCESS: '@@templates/GET_RESULT_BY_EDITOR_OBJECT_SUCCESS',
  GET_RESULT_BY_EDITOR_OBJECT_ERROR: '@@templates/GET_RESULT_BY_EDITOR_OBJECT_ERROR',

  UPDATE_RESULT: '@@templates/UPDATE_RESULT',
  RESET_RESULT: '@@templates/RESET_RESULT',
  SAVE_RESULT: '@@templates/SAVE_RESULT',
  CLEAR_RESULT: '@@templates/CLEAR_RESULT',

  CREATE_TEMPLATE_SCREENSHOT_REQUEST: '@@templates/CREATE_TEMPLATE_SCREENSHOT_REQUEST',
  CREATE_TEMPLATE_SCREENSHOT_SUCCESS: '@@templates/CREATE_TEMPLATE_SCREENSHOT_SUCCESS',
  CREATE_TEMPLATE_SCREENSHOT_ERROR: '@@templates/CREATE_TEMPLATE_SCREENSHOT_ERROR',

  DELETE_TEMPLATE_SCREENSHOT_REQUEST: '@@templates/REMOVE_TEMPLATE_SCREENSHOT_REQUEST',
  DELETE_TEMPLATE_SCREENSHOT_SUCCESS: '@@templates/REMOVE_TEMPLATE_SCREENSHOT_SUCCESS',
  DELETE_TEMPLATE_SCREENSHOT_ERROR: '@@templates/REMOVE_TEMPLATE_SCREENSHOT_ERROR',

  SHARE_TEMPLATE_WITH_CLIENTS_REQUEST: '@@templates/SHARE_TEMPLATE_WITH_CLIENTS_REQUEST',
  SHARE_TEMPLATE_WITH_CLIENTS_SUCCESS: '@@templates/SHARE_TEMPLATE_WITH_CLIENTS_SUCCESS',
  SHARE_TEMPLATE_WITH_CLIENTS_ERROR: '@@templates/SHARE_TEMPLATE_WITH_CLIENTS_ERROR',

  UPDATE_TEMPLATE_REQUEST: '@@templates/UPDATE_TEMPLATE_REQUEST',
  UPDATE_TEMPLATE_SUCCESS: '@@templates/UPDATE_TEMPLATE_SUCCESS',
  UPDATE_TEMPLATE_ERROR: '@@templates/UPDATE_TEMPLATE_ERROR',

  GET_AVAILABLE_CLIENT_TEMPLATES_REQUEST: '@@templates/GET_AVAILABLE_CLIENT_TEMPLATES_REQUEST',
  GET_AVAILABLE_CLIENT_TEMPLATES_SUCCESS: '@@templates/GET_AVAILABLE_CLIENT_TEMPLATES_SUCCESS',
  GET_AVAILABLE_CLIENT_TEMPLATES_ERROR: '@@templates/GET_AVAILABLE_CLIENT_TEMPLATES_ERROR',

  GET_OPERATION_TEMPLATES_REQUEST: '@@templates/GET_OPERATION_TEMPLATES_REQUEST',
  GET_OPERATION_TEMPLATES_SUCCESS: '@@templates/GET_OPERATION_TEMPLATES_SUCCESS',
  GET_OPERATION_TEMPLATES_ERROR: '@@templates/GET_OPERATION_TEMPLATES_ERROR',

  GET_OPERATION_TEMPLATE_REQUEST: '@@templates/GET_OPERATION_TEMPLATE_REQUEST',
  GET_OPERATION_TEMPLATE_SUCCESS: '@@templates/GET_OPERATION_TEMPLATE_SUCCESS',
  GET_OPERATION_TEMPLATE_ERROR: '@@templates/GET_OPERATION_TEMPLATE_ERROR',

  COPY_CLIENT_TEMPLATE_TO_PATH_REQUEST: '@@templates/COPY_CLIENT_TEMPLATE_TO_PATH_REQUEST',
  COPY_CLIENT_TEMPLATE_TO_PATH_SUCCESS: '@@templates/COPY_CLIENT_TEMPLATE_TO_PATH_SUCCESS',
  COPY_CLIENT_TEMPLATE_TO_PATH_ERROR: '@@templates/COPY_CLIENT_TEMPLATE_TO_PATH_ERROR',

  MODIFY_OPERATION_TEMPLATES_PATH_REQUEST: '@@templates/MODIFY_OPERATION_TEMPLATES_PATH_REQUEST',
  MODIFY_OPERATION_TEMPLATES_PATH_SUCCESS: '@@templates/MODIFY_OPERATION_TEMPLATES_PATH_SUCCESS',
  MODIFY_OPERATION_TEMPLATES_PATH_ERROR: '@@templates/MODIFY_OPERATION_TEMPLATES_PATH_ERROR',

  REMOVE_TEMPLATE_FROM_PATH_REQUEST: '@@templates/REMOVE_TEMPLATE_FROM_PATH_REQUEST',
  REMOVE_TEMPLATE_FROM_PATH_SUCCESS: '@@templates/REMOVE_TEMPLATE_FROM_PATH_SUCCESS',
  REMOVE_TEMPLATE_FROM_PATH_ERROR: '@@templates/REMOVE_TEMPLATE_FROM_PATH_ERROR',

  DELETION_OPERATION_TEMPLATES_PATH_REQUEST: '@@templates/DELETION_OPERATION_TEMPLATES_PATH_REQUEST',
  DELETION_OPERATION_TEMPLATES_PATH_SUCCESS: '@@templates/DELETION_OPERATION_TEMPLATES_PATH_SUCCESS',
  DELETION_OPERATION_TEMPLATES_PATH_ERROR: '@@templates/DELETION_OPERATION_TEMPLATES_PATH_ERROR',

  GET_SYSTEM_PAGES_REQUEST: '@@templates/GET_SYSTEM_PAGES_REQUEST',
  GET_SYSTEM_PAGES_SUCCESS: '@@templates/GET_SYSTEM_PAGES_SUCCESS',
  GET_SYSTEM_PAGES_ERROR: '@@templates/GET_SYSTEM_PAGES_ERROR',

  GET_SYSTEM_STYLES_REQUEST: '@@templates/GET_SYSTEM_STYLES_REQUEST',
  GET_SYSTEM_STYLES_SUCCESS: '@@templates/GET_SYSTEM_STYLES_SUCCESS',
  GET_SYSTEM_STYLES_ERROR: '@@templates/GET_SYSTEM_STYLES_ERROR',

  GET_MASTER_TEMPLATE_REQUEST: '@@templates/GET_MASTER_TEMPLATE_REQUEST',
  GET_MASTER_TEMPLATE_SUCCESS: '@@templates/GET_MASTER_TEMPLATE_SUCCESS',
  GET_MASTER_TEMPLATE_ERROR: '@@templates/GET_MASTER_TEMPLATE_ERROR',
};
